function scrollDetector(element) {
  const targetElement = document.querySelector(".product-form__buttons");
  const appliedElement = document.querySelector(element);
  if (!targetElement) {
    console.error("targetElement not found");
    return;
  }
  const options = {
    root: null,
    rootMargin: "0px",
    scrollMargin: "0px",
    threshold: 1.0,
  };
  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        console.log("is-hide");
        appliedElement.classList.add("is-hide");
        appliedElement.classList.remove("is-show");
      } else {
        console.log("is-show");
        appliedElement.classList.add("is-show");
        appliedElement.classList.remove("is-hide");
      }
    });
  };
  const observer = new IntersectionObserver(callback, options);
  console.log (observer.root )
  observer.observe(targetElement);
}